<header class="header">
  <div class="title">
    <kin-icon name="video" [color]="colorService.textColor() || 'white'" />
    <h3>{{ 'video_uploader.title' | translate | upperFirstLetter }}</h3>
  </div>
  @if (mediaBlockService.videoFileData()) {
    <p>
      <span>{{ 'common.file.name' | translate }}</span>
      {{ mediaBlockService.videoFileData()!.name }}
      <span>{{ 'common.file.duration' | translate }}</span>
      {{ mediaBlockService.videoFileData()!.duration | formatDuration }}
      <span>{{ 'common.file.weight' | translate }}</span>
      {{ mediaBlockService.videoFileData()!.weight | fileSize }}
    </p>
  } @else {
    @if (contentType() === 'scenic') {
      <p>{{ 'video_uploader.import_hint.scenic' | translate }}</p>
    } @else {
      <p>{{ 'video_uploader.import_hint.coaching' | translate }}</p>
    }
  }
</header>

@if (!mediaBlockService.videoFile()) {
  <div class="field-group">
    <label
      for="video"
      class="video-label"
      #videoDropzone
      (drop)="onVideoDrop($event)"
      (dragover)="setIsVideoDragOver($event, true)"
      (dragleave)="setIsVideoDragOver($event, false)"
      [class.error]="mediaForm().get('videoFile')?.invalid && mediaForm().get('videoFile')?.touched"
    >
      <header>
        <kin-icon name="upload" color="#428FF3" />
        <h5>{{ 'video_uploader.upload_title' | translate }}<span class="requied">*</span></h5>
        <p>{{ 'video_uploader.upload_hint' | translate }}</p>
      </header>
      <footer>
        <span class="files-type-required-label">{{ 'common.file.format' | translate }}</span>
        <span class="files-type-required-list"> .{{ authorizeVideoFormats.join(' .') }}</span>
      </footer>
    </label>
    @if (mediaForm().get('videoFile')?.invalid && mediaForm().get('videoFile')?.touched) {
      <p class="field-error">{{ 'common.required_field' | translate }}</p>
    }
  </div>
} @else {
  <div class="video-container">
    @if (isStop() && videoPlayer() && overlay()) {
      <div class="play-icon" (click)="videoPlayer()?.nativeElement?.play()">
        <kin-icon name="play" color="white" />
      </div>
    }

    @if (thumbnailUrl()) {
      <button class="thumbnail-file-btn" (click)="onChangeThumbnailClick()">
        <img [src]="thumbnailUrl()" [alt]="'video_uploader.thumbnail_alt' | translate" />
        <p>{{ 'video_uploader.thumbnail' | translate | upperFirstLetter }}</p>
        <p class="time">{{ videoThumbnailTimstamp | timer }}</p>
      </button>
    }

    <button (click)="onRemoveVideo()" class="remove-file-btn">
      <kin-icon name="trash" color="#EA302D" />
      <p>{{ 'common.delete' | translate | titlecase }}</p>
    </button>

    @if (videoPlayer()) {
      <app-player-controls
        [videoPlayer]="videoPlayer()!"
        [style.opacity]="overlay() ? '0' : '1'"
        [style.pointerEvents]="overlay() ? 'none' : 'auto'"
      />
    }

    @if (mediaBlockService.videoUrl()) {
      <video
        #videoElement
        (play)="isStop.set(false)"
        (pause)="isStop.set(true)"
        (ended)="isStop.set(true)"
        (loadedmetadata)="videoLoaded($event)"
        (timeupdate)="onVideoTimeUpdate($event)"
        [controls]="false"
        [src]="mediaBlockService.videoUrl()"
        width="640"
        height="360"
        (mouseenter)="mouseOut.set(false)"
        (mouseleave)="mouseOut.set(true)"
      >
        {{ 'video_uploader.unsupported_browser' | translate }}
      </video>
    }
  </div>
}
<input
  type="file"
  name="video"
  id="video"
  [multiple]="false"
  accept="video/mp4,video/quicktime,video/mpeg"
  (change)="onSelectVideoFile($event)"
  #videoInput
/>
